export const NAME_POLICY_MSG: string = "Please enter a new Name.";
export const NAME_UPDATE_SUCCESS: string = "Name update successful";
export const NAME_UPDATE_FAIL: string = "Name update failed";
export const EMAIL_POLICY_MSG: string = "Please enter a new email.";
export const EMAIL_UPDATE_SUCCESS: string = "Email update successful";
export const EMAIL_UPDATE_FAIL: string = "Email update failed";
export const PASSWORD_POLICY_MSG: string =
	"Please enter a password that is at least 7 characters long, and contains 3 of the following categories: Uppercase characters (A, B, ..., Z), Lowercase characters (a, b, ..., z), Numbers (1, 2, ..., 9), Symbols (~`!@#$%^&*_+{}:?><)";
export const PASSWORD_NO_MATCH: string = "The passwords entered do not match!";
export const ERROR_MSG_PROFILE: string =
	"The profile details could not be fetched. Please try again later!";
export const ERROR_PASSWORD_UPDATE: string =
	"The password could not be updated. Please try again later!";
export const SUCCESS_PASSWORD_UPDATE: string =
	"The password was successfully updated!";
export const GROUPS_DESCRIPTION =
	"Groups provide teachers an easy and flexible way to manage all your students in the one place. To get started, create a new group and add some students. You can now instantly assign activities and quests to multiple students at once.";
export const CONFIRM_DELETE =
	"Do you really want to delete the selected users from the group?";
export const NO_MATCHING_USERS =
	"We could not find any users matching that name!";
export const ADDED_USR = "The user was successfully added!";
export const LICENSE_EXPLANATION_MSG =
	"If you are setting up an account on behalf of your school, continue ahead as an administrator. Alternatively, if you are a teacher without a school license, use our teacher license to get started.";
export const GROUP_NAME_NO_EMPTY = "Please enter the group name!";
export const DELETE_FAIL = "Operation failed, please try again!";
export const GROUP_DISPLAY_ERROR = "Group can't be shown, please try again!";
export const CREATE_GROUP_ERROR = "Creating group failed, please try again!";
export const ADD_STUDENTS_TO_GROUP_ERROR =
	"Adding students failed, please try again";
export const ERR_SEARCH =
	"Sorry, something went wrong. Please try again later!";
export const ERR_CREATE =
	"Sorry, something went wrong. Please try again later!";
export const ACCOUNT_ADD_PAGE_DESC =
	"Easily add other users to your account, to assign the fun activities within" +
	" Science Island to your students. If you're a teacher, use this to add the details of your students to get your" +
	" class set up with Science Island. School administrators can also use this to add students, and school staff to" +
	" start their Science Island journey!";
export const ASSIGNMENT_NEEDS_GROUP =
	"Before you can create an assignment, you must first create a group.";
export const ACTIVITIES_FETCH_ERR =
	"Sorry, we could not load the existing activities.";
export const DELETE_ASSIGNMENT_CONFIRMATION =
	"Are you sure you want to permanently delete this assignment?";
export const DUPLICATE_EMAIL =
	"An account with this email has already been created.";
export const ERR_REGISTER =
	"Sorry, something went wrong. Please try again later!";
export const ADD_ADMIN = "Are you sure you want to add admin permissions?";
export const REMOVE_ADMIN =
	"Are you sure you want to remove admin permissions?";
export const ADD_ADMIN_SUCC = "Added admin permissions successfully!";
export const ADD_ADMIN_FAIL = "Adding admin permissions failed!";
export const REMOVE_ADMIN_SUCC = "Removing admin permissions succeeded!";
export const REMOVE_ADMIN_FAIL = "Removing admin permissions failed!";
export const LEADER_BOARD = "Sorry, we could not load the leaderboard";
export const GET_RESULT_FAIL = "Sorry, we could not load the result";
export const UPDATE_CHILD_RELATION = "Please enter your child's email address.";
export const INVALID_EMAIL = "The email entered is invalid!";
export const ERROR_ADD_CHILD_TO_PARENT =
	"Sorry, the entered email is invalid. Please check it and try again!";
export const SUCCESS_ADD_CHILD_TO_PARENT: string =
	"You are successfully linked to your child!";
export const SUCCESS_UPDATE_TOPIC_GRADE: string =
	"Updated student's topic grades successfully!";
export const SUCCESS_UPDATE_CAPABILITY_GRADE: string =
	"Updated student's general capability grades successfully!";
export const SUCCESS_ADD_COMMENT: string = "Added you comment successfully!";
export const SUCCESS_UPDATE_COMMENT: string =
	"Updated you comment successfully!";
export const SOMETHING_WENT_WRONG: string =
	"Sorry, something went wrong. Please try again later!";
